import React from 'react';
import { useHistory } from 'react-router-dom';
import { Button } from '@material-ui/core';
import FallasDesembarques from './FallasDesembarques';

const FallasDesembarquesIndex = () => {
    const history = useHistory();

    return (
        <div className="w-full p-4 md:p-6">
            <div className="flex justify-between items-center mb-6">
                <h1 className="text-2xl font-bold text-gray-900 tracking-tight">Fallas de Desembarque</h1>
                <div className="flex space-x-2">
                    <Button
                        className="bg-blue-600 hover:bg-blue-700 text-white font-bold py-2 px-6 rounded-full shadow-md"
                        variant="contained"
                        color="primary"
                        onClick={() => history.push(`/Catalogo/FallaDesembarque`)}
                    >
                        + Nuevo Falla de Desembarque
                    </Button>
                </div>
            </div>

            <FallasDesembarques />
        </div>
    );
};

export default FallasDesembarquesIndex;
